import { render, staticRenderFns } from "./man-employee-grant.vue?vue&type=template&id=86955a3c"
import script from "./man-employee-grant.vue?vue&type=script&lang=js"
export * from "./man-employee-grant.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports